<template>
  <div
    class="bg-neutral-20 rounded-lg q-pa-md text-neutral"
    :class="containerTextClass"
    style="white-space: pre-line"
  >
    <div
      v-if="template?.header?.text"
      class="q-mb-sm text-weight-medium"
      :class="headerTextClass"
    >
      {{ template.header.text }}
    </div>

    <div
      v-if="template?.bodyOriginal"
      class="q-mb-sm"
      :class="bodyTextClass"
      v-html="renderedPreview"
    ></div>

    <div
      v-if="template?.footer"
      class="text-neutral-70 q-mt-sm"
      :class="footerTextClass"
    >
      {{ template.footer }}
    </div>

    <div v-if="template?.buttons?.length" class="row q-gutter-md q-mt-md">
      <div
        v-for="(btn, idx) in template.buttons"
        :key="idx"
        class="bg-primary-10 text-neutral rounded q-px-md q-py-xs"
        :class="buttonTextClass"
        style="pointer-events: none; user-select: text"
      >
        {{ btn.parameter?.text }}
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  template: { type: Object, required: true },
  formData: { type: Object, default: () => ({}) },
});

const { isFloating } = inject("floating-chat-dialog", {});

// Computed classes based on isFloating
const containerTextClass = computed(() =>
  unref(isFloating) ? "text-xs" : "text-sm",
);

const headerTextClass = computed(() => (unref(isFloating) ? "text-xs" : ""));

const bodyTextClass = computed(() => (unref(isFloating) ? "text-xxs" : ""));

const footerTextClass = computed(() =>
  unref(isFloating) ? "text-xxs" : "text-xs",
);

const buttonTextClass = computed(() =>
  unref(isFloating) ? "text-xxs" : "text-sm",
);

const renderedPreview = computed(() => {
  const { bodyOriginal = "" } = props.template || {};

  const processedBody = Object.entries(props.formData || {}).reduce(
    (body, [key, value]) => {
      const regex = new RegExp(String.raw`{{\s*${key}\s*}}`, "g");

      return body.replace(regex, value || `{{${key}}}`);
    },
    bodyOriginal,
  );

  return processedBody
    .replaceAll("\n", "<br/>")
    .replaceAll(/\*(.*?)\*/g, "<b>$1</b>");
});
</script>
